import React, { useState, useEffect } from 'react';
import request from '@/services/request.service';
import { toFormData } from '@/utils/convert.util';
import { getLocaleWordContent } from '@/utils/language.util';

function ListItem({ item }) {
    return (
        <tr>
            <td className="title" style={item.status === '1' ? { color: 'red' } : {}}>
                {item.title}{' '}
            </td>

            <td className="content">
                <span dangerouslySetInnerHTML={{ __html: item.content }}></span>
            </td>

            <td className="date">{item.date} </td>
        </tr>
    );
}

function Inquiry({ ModalActions }) {
    const [list, setList] = useState([]);

    useEffect(() => {
        _get_list();
    }, []);

    const _get_list = async () => {
        const param = { b_type: 'inquiry' };
        const rsp = await request
            .post('/api/board/board_list.php', toFormData(param))
            .then((response) => response.data);
        if (rsp.result < 0) {
            return null;
        } else {
            setList(rsp.list);
            return rsp;
        }
    };
    const handleOpenModal = (e) => {
        ModalActions.showModalEx({ mode: 4 });
    };
    const handleClose = () => {
        ModalActions.showModalEx({ mode: 0 });
    };
    return (
        <div className="popup_01">
            <div className="popup_inner01 pop_inquiry">
                <img
                    src={require('@/resources/assets/images/close.png')}
                    className="popup_close"
                    alt="close"
                    onClick={handleClose}
                />
                <h2>
                    <div className="inner">1:1{getLocaleWordContent('문의')}</div>
                </h2>
                <div className="inner">
                    <div className="sp10"></div>
                    <button className="b_blue btn01 btn02" onClick={handleOpenModal}>
                        {getLocaleWordContent('글쓰기')}
                    </button>
                    <div className="sp15"></div>
                    {/* {list.length === 0 ? (
                        <div className="inquiry_div">
                            <p className="title">1:1 Inquiry</p>
                            <p className="title">If you have any questions, please leave a message.</p>
                        </div>
                    ) : (
                        list.map((item, index) => <ListItem key={index} item={item} />)
                    )} */}
                    <div className="history_box history_box01 t_pink">
                        <div className="table_body">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{getLocaleWordContent('제목')}</th>
                                        <th>{getLocaleWordContent('내용')}</th>
                                        <th>{getLocaleWordContent('날짜')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.length > 0 && list.map((item, index) => <ListItem key={index} item={item} />)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Inquiry;
